import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, takeUntil } from 'rxjs';
import {
  FormBuilderFieldTypes,
  GetEnumValuesDto,
  GetFormBuilderResponsesByIdDto,
} from 'src/app/core/api/models';
import { FormBuildersService } from 'src/app/core/api/services';

import { EventTypes } from 'src/app/core/constants/event-types';
import { TranslationService } from 'src/app/i18n';
import { BaseIndexModule } from 'src/app/pages/shared/base';
import { BaseIndexPageComponent } from 'src/app/pages/shared/base/components/base-index-page.component';

@Component({
  selector: 'app-form-builder-responses-detail',
  templateUrl: './form-builder-responses-detail.component.html',
  standalone: true,
  imports: [BaseIndexModule],
})
export class FormBuilderResponsesDetailComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  loading;
  SmsAggregatorEnumValues: GetEnumValuesDto[] = [];
  FormBuilderFieldTypesEnumValues: GetEnumValuesDto[] = [];

  get FormBuilderFieldTypes() {
    return FormBuilderFieldTypes;
  }

  @Input('responseModel') model: GetFormBuilderResponsesByIdDto;
  @Output('closePage') output_closPage = new EventEmitter<boolean>();

  //#endregion

  constructor(
    public translationService: TranslationService,
    protected currentService: FormBuildersService
  ) {
    super();
  }

  ngOnInit() {
    try {
      this.getEnumsValues();
      this.getUserState();
      this.configTableColumns();
      this.initTablePagination();
      this.configPage();
      this.pageConfig.tableConfig.showTableShadow = false;
      this.pageConfig.tableConfig.hidePagination = true;
      this.pageConfig.tableConfig.showDeleteFilters = false;

      this.pageConfig.tableConfig.showOperationColumn = false;
      this.pageConfig.title = 'common.detail';
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.whiteMessages
      );
    }
  }

  getEnumsValues() {
    this.getEnumValuesApi('SmsAggregator')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.SmsAggregatorEnumValues = values));
    this.getEnumValuesApi('FormBuilderFieldTypes')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.FormBuilderFieldTypesEnumValues = values));
  }

  getVocabs() {}

  configTableColumns() {
    this.tableColumns = [
      {
        title: 'common.title',
        name: 'formBuilderFieldTitle',
        noSorting: true,
      },
      {
        title: 'common.fieldType',
        name: 'fieldType',
        hasSearch: false,
        noSorting: true,
        type: 'enum',
        enumName: 'FormBuilderFieldTypes',
      },
      { title: 'common.response', name: 'response', noSorting: true },
    ];
  }

  //#region Api

  getPaginationApi(): Observable<any> {
    return;
  }

  //#endregion

  onClose() {
    this.output_closPage.emit(true);
  }

  unSubs() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
